import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import DataContext from '../../store/dataContext';
import useCurrency from '../../modules/currency/hooks/use-currency';

import './style.scss';

const StoreCredit = () => {
  const { t } = useTranslation();

  const { getShoppercurrency } = useCurrency();

  const { apiEmailResponse, applyStoreCredit, setApplyStoreCredit, cartTotals, contextShippingAddress } =
    useContext(DataContext);
  const dollarUSLocale = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: getShoppercurrency()?.code || 'USD',
  });

  const handleCreditToShow = () => {
    if (apiEmailResponse.availableStoreCredit >= cartTotals?.data?.total && contextShippingAddress?.line1) {
      return cartTotals?.data?.total;
    }
    if (apiEmailResponse.availableStoreCredit >= cartTotals?.data?.total) {
      return cartTotals?.data?.total - cartTotals?.data?.shipping;
    }
    if (apiEmailResponse.availableStoreCredit > cartTotals?.data?.subtotal) {
      return cartTotals?.data?.subtotal;
    }
    return apiEmailResponse.availableStoreCredit;
  };

  return (
    <div className="store-credit">
      <input
        className="store-checkbox"
        type="checkbox"
        checked={applyStoreCredit}
        onChange={() => setApplyStoreCredit(!applyStoreCredit)}
      />
      <span className="store-span">{t('store_credit.apply')}</span>
      <span className="store-value">
        {t('store_credit.empty')}
        {dollarUSLocale.format(handleCreditToShow())}
        {t('store_credit.empty')}
      </span>
      <span className="store-span">{t('store_credit.store_credit')}</span>
    </div>
  );
};

export default StoreCredit;
